
// let mainSwiper = new Swiper('.swiper-product-page', {
//     slidesPerView: 1,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     loop: false,
// });

// let thumbSwiper = new Swiper('.swiper-thumbs', {
//     slidesPerView: 4,
//     spaceBetween: 10,
//     loop: false,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
// });

// function selectedVariantImage(matchedVariant) {
//     if (matchedVariant && matchedVariant.featured_image) {
//         document.querySelector('#product__image').setAttribute('src', matchedVariant.featured_image.src);

//         document.querySelectorAll('.swiper-thumbs .swiper-slide').forEach(slide => {
//             slide.classList.remove('swiper-slide-active');
//         });

//         const thumbnailIndex = matchedVariant.featured_image.position - 1;
//         const thumbnails = document.querySelectorAll('.swiper-thumbs .swiper-slide');
//         if (thumbnails[thumbnailIndex]) {
//             thumbnails[thumbnailIndex].classList.add('swiper-slide-active');


//             if (thumbSwiper && typeof thumbSwiper.slideTo === 'function') {
//                 thumbSwiper.slideTo(thumbnailIndex);
//             }
//         }


//         if (mainSwiper && typeof mainSwiper.slideTo === 'function') {
//             mainSwiper.slideTo(thumbnailIndex);
//         }
//     } else {
//         console.error("No matched variant or featured image.");
//     }
// }


// window.theme = window.theme || {};

// document.querySelectorAll('input[type="radio"]').forEach(radio => {
//     radio.addEventListener("change", () => {

//         const selectedOptions = [];
//         document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
//             selectedOptions.push(radio.value);

//         });

//         // Find the matched variant
//         const matchedVariant = product_variant.variants.find(variant => {
//             return selectedOptions.every((option, index) => option === variant.options[index]);
//         });

//         console.log("Matched Variant:", matchedVariant);
//         selectedVariantImage(matchedVariant)

//     });
// });

function selectedVarint() {
    var slectedId = $(".select__variant").val();
    console.log(slectedId);
    var url = new URL(window.location.href);
    url.searchParams.set("variant", slectedId);
    window.history.replaceState({}, "", url);
}


function selectedUpdate() {
    var updateValue = "";
    $(".product-information input[type='radio']:checked").each(
        function () {

            updateValue += (updateValue ? " / " : "") + $(this).val();

        }
    );



    $(".select__variant option").each(function () {

        var optionValue = $(this).text().trim();

        if (optionValue == updateValue) {
            $(this).prop("selected", true);
            var sale__price = $(this).attr("data-variant-price");
            console.log(sale__price)
            $(".product__price").text(sale__price);
            return true;
        }


    });

}

$(".product-information input[type='radio']").change(function () {

    selectedUpdate();
    selectedVarint();
});
// selectedUpdate();
// selectedVarint();

// document.addEventListener("DOMContentLoaded", function () {
//     // Check if the product_variant object is defined
//     if (typeof product_variant === 'undefined' || !product_variant.variants) {
//         console.error("Product variant data is not defined.");
//         return;
//     }

//     // Initialize Swiper instances
//     var mainSwiper = new Swiper('.swiper-product-page', {
//         slidesPerView: 1,
//         navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//         },
//         loop: false,
//     });

//     var thumbsSwiper = new Swiper('.swiper-thumbs', {
//         slidesPerView: 'auto',
//         spaceBetween: 10,
//         watchSlidesVisibility: true,
//         watchSlidesProgress: true,
//     });

//     // Link mainSwiper with thumbsSwiper
//     mainSwiper.controller.control = thumbsSwiper;
//     thumbsSwiper.controller.control = mainSwiper;

//     // Initialize the image based on the selected variant when the page loads
//     initializeVariantImage();

//     // Add event listeners to variant option radios
//     document.querySelectorAll('input[type="radio"]').forEach(radio => {
//         radio.addEventListener("change", updateVariantImage);
//     });

//     function initializeVariantImage() {
//         var selectedOptions = getSelectedOptions();
//         var matchedVariant = findMatchedVariant(selectedOptions);

//         if (matchedVariant && matchedVariant.featured_image) {
//             updateMainImage(matchedVariant.featured_image.src);
//             activateThumbnail(matchedVariant.featured_image.position);
//             mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
//         }
//     }

//     function updateVariantImage() {
//         var selectedOptions = getSelectedOptions();
//         var matchedVariant = findMatchedVariant(selectedOptions);

//         if (matchedVariant && matchedVariant.featured_image) {
//             updateMainImage(matchedVariant.featured_image.src);
//             activateThumbnail(matchedVariant.featured_image.position);
//             mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
//         }
//     }

//     function getSelectedOptions() {
//         var selectedOptions = [];
//         document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
//             selectedOptions.push(radio.value);
//         });
//         return selectedOptions;
//     }

//     function findMatchedVariant(selectedOptions) {
//         return product_variant.variants.find(variant => {
//             return selectedOptions.every((option, index) => option === variant.options[index]);
//         });
//     }

//     function updateMainImage(imageSrc) {
//         var productImage = document.querySelector('#product__image');
//         if (productImage) {
//             productImage.setAttribute('src', imageSrc);
//         } else {
//             console.error("#product__image element not found.");
//         }
//     }

//     function activateThumbnail(position) {
//         var thumbnails = document.querySelectorAll('.swiper-thumbs .swiper-slide');
//         if (thumbnails.length > 0) {
//             thumbnails.forEach(slide => slide.classList.remove('swiper-slide-active'));
//             var thumbnail = thumbnails[position - 1];
//             if (thumbnail) {
//                 thumbnail.classList.add('swiper-slide-active');
//             } else {
//                 console.error("Thumbnail for position", position, "not found.");
//             }
//         }
//     }
// });




// document.addEventListener("DOMContentLoaded", function () {
//     // Check if the product_variant object is defined
//     if (typeof product_variant === 'undefined' || !product_variant.variants) {
//         console.error("Product variant data is not defined.");
//         return;
//     }

//     // Initialize Swiper instances
//     var mainSwiper = new Swiper('.swiper-product-page', {
//         // slidesPerView: 1,
//         // navigation: {
//         //     nextEl: '.swiper-button-next',
//         //     prevEl: '.swiper-button-prev',
//         // },
//         // loop: false,
//     });
//     var thumbsSwiper = new Swiper('.swiper-thumbs', {
//         slidesPerView: 5,
//         spaceBetween: 10,
//         watchSlidesVisibility: true,
//         watchSlidesProgress: true,
//     });


//     // Link mainSwiper with thumbsSwiper
//     mainSwiper.controller.control = thumbsSwiper;
//     thumbsSwiper.controller.control = mainSwiper;

//     // Initialize the image based on the selected variant when the page loads
//     initializeVariantImage();

//     // Add event listeners to variant option radios
//     document.querySelectorAll('input[type="radio"]').forEach(radio => {
//         radio.addEventListener("change", updateVariantImage);
//     });

//     function initializeVariantImage() {
//         var selectedOptions = getSelectedOptions();
//         var matchedVariant = findMatchedVariant(selectedOptions);

//         if (matchedVariant && matchedVariant.featured_image) {
//             updateMainImage(matchedVariant.featured_image.src);
//             activateThumbnail(matchedVariant.featured_image.position);
//             mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
//             // Check and slide the thumbnail swiper
//             if (thumbsSwiper && typeof thumbsSwiper.slideTo === 'function') {
//                 thumbsSwiper.slideTo(matchedVariant.featured_image.position - 1);
//             }
//         }
//     }

//     function updateVariantImage() {
//         var selectedOptions = getSelectedOptions();
//         var matchedVariant = findMatchedVariant(selectedOptions);

//         if (matchedVariant && matchedVariant.featured_image) {
//             updateMainImage(matchedVariant.featured_image.src);
//             activateThumbnail(matchedVariant.featured_image.position);
//             mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
//             // Check and slide the thumbnail swiper
//             if (thumbsSwiper && typeof thumbsSwiper.slideTo === 'function') {
//                 thumbsSwiper.slideTo(matchedVariant.featured_image.position - 1);
//             }
//         }
//     }

//     function getSelectedOptions() {
//         var selectedOptions = [];
//         document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
//             selectedOptions.push(radio.value);
//         });
//         return selectedOptions;
//     }

//     function findMatchedVariant(selectedOptions) {
//         return product_variant.variants.find(variant => {
//             return selectedOptions.every((option, index) => option === variant.options[index]);
//         });
//     }

//     function updateMainImage(imageSrc) {
//         var productImage = document.querySelector('#product__image');
//         if (productImage) {
//             productImage.setAttribute('src', imageSrc);
//         } else {
//             console.error("#product__image element not found.");
//         }
//     }

//     function activateThumbnail(position) {
//         var thumbnails = document.querySelectorAll('.swiper-thumbs .swiper-slide');
//         if (thumbnails.length > 0) {

//             thumbnails.forEach(slide => slide.classList.remove('swiper-slide-active'));
//             var thumbnail = thumbnails[position - 1];

//             if (thumbnail) {

//                 thumbnail.classList.add('swiper-slide-active');
//                 // Check and slide the thumbnail swiper
//                 if (thumbsSwiper && typeof thumbsSwiper.slideTo === 'function') {
//                     thumbsSwiper.slideTo(position - 1); // Slide to the active thumbnail
//                 }
//             } else {
//                 console.error("Thumbnail for position", position, "not found.");
//             }
//         }
//     }
// });

document.addEventListener("DOMContentLoaded", function () {
    // Check if the product_variant object is defined
    if (typeof product_variant === 'undefined' || !product_variant.variants) {
        console.error("Product variant data is not defined.");
        return;
    }

    // Initialize Swiper instances
    var mainSwiper = new Swiper('.swiper-product-page', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
    });

    var thumbsSwiper = new Swiper('.swiper-thumbs', {
        slidesPerView: 5, // Change to auto to accommodate different numbers of thumbnails
        spaceBetween: 10,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    // Link mainSwiper with thumbsSwiper
    mainSwiper.controller.control = thumbsSwiper;
    thumbsSwiper.controller.control = mainSwiper;

    // Initialize the image based on the selected variant when the page loads
    initializeVariantImage();

    // Add event listeners to variant option radios
    document.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener("change", updateVariantImage);
    });

    function initializeVariantImage() {
        var selectedOptions = getSelectedOptions();
        var matchedVariant = findMatchedVariant(selectedOptions);

        if (matchedVariant && matchedVariant.featured_image) {
            updateMainImage(matchedVariant.featured_image.src);
            activateThumbnail(matchedVariant.featured_image.position);
            mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
        }
    }

    function updateVariantImage() {
        var selectedOptions = getSelectedOptions();
        var matchedVariant = findMatchedVariant(selectedOptions);

        if (matchedVariant && matchedVariant.featured_image) {
            updateMainImage(matchedVariant.featured_image.src);
            activateThumbnail(matchedVariant.featured_image.position);
            mainSwiper.slideTo(matchedVariant.featured_image.position - 1);
        }
    }

    function getSelectedOptions() {
        var selectedOptions = [];
        document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
            selectedOptions.push(radio.value);
        });
        return selectedOptions;
    }

    function findMatchedVariant(selectedOptions) {
        return product_variant.variants.find(variant => {
            return selectedOptions.every((option, index) => option === variant.options[index]);
        });
    }

    function updateMainImage(imageSrc) {
        var productImage = document.querySelector('#product__image');
        if (productImage) {
            productImage.setAttribute('src', imageSrc);
        } else {
            console.error("#product__image element not found.");
        }
    }

    function activateThumbnail(position) {
        var thumbnails = document.querySelectorAll('.swiper-thumbs .swiper-slide');
        if (thumbnails.length > 0) {
            thumbnails.forEach(slide => slide.classList.remove('swiper-slide-active'));
            var thumbnail = thumbnails[position - 1];

            if (thumbnail) {
                thumbnail.classList.add('swiper-slide-active');

                // Slide to the active thumbnail only if it exists and the function is available
                if (thumbsSwiper && typeof thumbsSwiper.slideTo === 'function') {
                    thumbsSwiper.slideTo(position - 1);
                }
            } else {
                console.error("Thumbnail for position", position, "not found.");
            }
        }
    }
});
